// src/features/scope_module/DemoScopePage.js
import React, { useEffect, useRef, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { useScope, DemoScopeProvider } from '../../contexts/DemoScopeContext';
import DemoHeader from './components/DemoHeader';
import LeftPanel from './components/LeftPanel';
import RightPanel from './components/RightPanel';
import Workspace from './components/Workspace';
import InstructionsModal from './components/InstructionsModal';
import './ScopeModule.css';


const ScopeComponent = () => {
  const scopeContext = useScope();
  const {
    isLoading, error, sessionDetails,

    // mode
    setReviewMode, setReadOnly,

    // state setters from context
    setLayersReady: setLayersReadyFlag,

    // layers
    ensureDefaultLayers,
  } = scopeContext;

  const bootRef = useRef(false);

  // Instructions modal state
  const [showInstructionsModal, setShowInstructionsModal] = useState(false);
  const instructionsShownRef = useRef(false);

  useEffect(() => {
    if (bootRef.current) return;

    if (isLoading || !sessionDetails) return;

    bootRef.current = true;

    (async () => {
      try {
        // Set up demo mode - NOT review mode, user needs to interact
        if (typeof setReviewMode === 'function') setReviewMode(false);
        if (typeof setReadOnly === 'function') setReadOnly(false);

        await new Promise(r => setTimeout(r, 50));

        await ensureDefaultLayers();

        if (typeof setLayersReadyFlag === 'function') setLayersReadyFlag(true);

        await new Promise(r => setTimeout(r, 50));

        // Show instructions modal if not dismissed
        if (!instructionsShownRef.current && InstructionsModal.shouldShow()) {
          setShowInstructionsModal(true);
          instructionsShownRef.current = true;
        }

      } catch (e) {
        console.warn('Demo boot failed:', e);
      }
    })();
  }, [
    sessionDetails, isLoading,
    setReviewMode, setReadOnly,
    setLayersReadyFlag,
    ensureDefaultLayers
  ]);

  const handleInstructionsClose = () => {
    // Just close the modal - user will manually start tracking
    setShowInstructionsModal(false);
  };

  if (isLoading || !sessionDetails) return <div className="loading-container">Loading Demo...</div>;
  if (error) return <div className="loading-container error-container">ERROR: {error}</div>;

  return (
    <div className="scope-module">
      <DemoHeader sessionDetails={sessionDetails} />
      <div className="main-content">
        <LeftPanel />
        <Workspace />
        <RightPanel />
      </div>

      {/* Instructions Modal */}
      <InstructionsModal
        isOpen={showInstructionsModal}
        onClose={() => setShowInstructionsModal(false)}
        onStart={handleInstructionsClose}
      />
    </div>
  );
};

const DemoScopePage = ({ onExit }) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <DemoScopeProvider onExit={onExit}>
        <ScopeComponent />
      </DemoScopeProvider>
    </DndProvider>
  );
};

export default DemoScopePage;